import { Component, ElementRef, OnInit, Renderer2 } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { first } from 'rxjs';
import { ApiServiceService } from 'src/app/_service/api-service.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { DatePipe } from '@angular/common';
import * as $ from 'jquery';
import { TimeScale } from 'chart.js';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-student-register',
  templateUrl: './student-register.component.html',
  styleUrls: ['./student-register.component.scss'],
})
export class StudentRegisterComponent implements OnInit {
  district_list: any[] = this.ApiService.all_districts;
  users: any;
  //  = JSON.parse(localStorage.getItem('login_user_details'));
  district: any;
  constituency: string = '';
  OBConstituency: string;
  user_constituency: any = this.ApiService.all_constituency['Chennai North'];
  assigned_to: any;
  zones: any = this.ApiService.zones;
  //user_name: any= this.ApiService.user_details.firstname;
  user_id: any;
  // = this.ApiService.user_details.id;
  activity_type: any;
  activity_date: any;
  activity_time: any;
  activity: any;
  description: any;
  status: any;
  others: any;
  customers: any = [];
  summary_activity: any = [];
  MeetingOptions: any;
  parentNumber: string = ''; // Used for two-way data binding

  participantsptions: any;
  // districts:any=['Salem','Karur','Namakkal','Trichy'];
  createmeetingform!: FormGroup;
  constituencies!: any;
  meeting_name: any;
  meeting_time: any;
  meeting_date: any;
  participants: any;
  meeting_type: any;
  meeting_location: any;
  spinner: boolean;
  hidden: boolean = true;
  dropdownList: string[] = [];
  dropdownSettings: IDropdownSettings = {};
  add = [];
  name: any;
  father_name: any;
  DOB: any;
  email: any;
  number: any;
  parent_number: any;
  grade: any;
  college_name: any;
  subject: any;
  uploadFiles: any = '';
  password: any;
  confirm_password: any;

  selectedItems = [];

  dropDownForm: FormGroup;
  tableshow: boolean = false;
  editmeetingform!: FormGroup;
  CM_id: any;
  CM_zone: any;
  password_wrong: boolean = false;

  getChangeAssignedTo(assigned_to: any) {
    if (assigned_to === 'District') {
      $('#Check1').css('display', 'flex');
    } else {
      $('#Check1').css('display', 'none');
    }
    if (assigned_to === 'Zone') {
      $('#zones').css('display', 'block');
    } else {
      $('#zones').css('display', 'none');
    }
  }

  getChangeToConstituey(value: any) {
    this.user_constituency = this.ApiService.all_constituency[value];
    this.ApiService.datablelogin(value).subscribe((data: any) => {
      let obj = data;
      this.customers = obj.data;
    });
  }

 

  handleActivityTypeChange(value: any) {
    if (value === 'Others') {
      $('#others').css('display', 'block');
    } else {
      $('#others').css('display', 'none');
    }
  }

  handleDeleteClick(id: any) {
    $(`#adding_${id}`).remove();
  }

  constructor(
    private fb: FormBuilder,
    private ApiService: ApiServiceService,
    private router: Router,
    private spinnerService: NgxSpinnerService,
    public datepipe: DatePipe,
    private elementRef: ElementRef,
    private renderer: Renderer2
  ) {
    this.createmeetingform = this.fb.group({
      name: ['', [Validators.required, Validators.pattern('[A-Za-z ]{1,32}')]],
      father_name: ['', [Validators.required, Validators.pattern('[A-Za-z ]{1,32}')]],
      DOB: ['', [Validators.required, this.validateDOB.bind(this)]],
    //  DOB: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.email, Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$')]],
      number: ['', [Validators.required, Validators.pattern('[6789][0-9]{9}')]],
      parent_number: ['', [Validators.required, Validators.pattern('[6789][0-9]{9}')]],
      grade: ['', Validators.required],
      college_name: ['', Validators.required],
      district: ['', Validators.required],
     // subject: ['', Validators.required],
      // image: ['', [Validators.required, this.imageSizeValidator(60000)]],
      password:  ['',[ Validators.required,this.passwordValidator()]],
      confirm_password: ['', Validators.required]
    }, { validator: this.passwordMatchValidator });
    //  { validator: this.differentNumberValidator('number', 'parent_number')});
    
    this.editformInitialize('false');
    
  }
  captchaError: boolean = false;
  recaptchaToken: string | null = null;    
    captchaResolved: boolean = false;


  onCaptchaResolved(response: string) {
    if (response) {
      this.recaptchaToken = response;
      this.captchaResolved = true;
      this.captchaError = false;
      //console.log(Resolved captcha with response: ${response});
    } else {
      this.captchaResolved = false;
      this.captchaError = true;
    }
  }
  differentNumberValidator(numberControlName: string, parentNumberControlName: string): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const number = control.get(numberControlName)?.value;
    const parentNumber = control.get(parentNumberControlName)?.value;
    if (number === parentNumber) {
      return { sameNumber: true };
    }
    return null;
  };
}
test_pr='false';
getlogincheck(c) {
  console.log(c.length)
  if(c.length>=10){
  if (c == this.createmeetingform.get('number').value) {
    this.test_pr = 'true';
  } else {
    this.test_pr = 'false';

  }}

 // Return null if numbers are different (valid)
}


  dtOptions: DataTables.Settings = {};
  date: any;
  ngOnInit(): void {
    this.date = new Date();
    // document.write(today);
    this.customers = [];
    this.showSpinner();
    this.ApiService.getStudentsList().subscribe((data: any) => {
      this.customers = data;
      this.tableshow = true;
    });

    this.dtOptions = {
      pagingType: 'full_numbers',
    };

    const all_districts = this.ApiService.meeting_districts;
    this.dropdownList = all_districts;

    this.selectedItems = [{}];
    this.dropDownForm = this.fb.group({
      meeting_district: [this.selectedItems],
    });
  }
  //Default date time in form
  current_date: any;
  current_time;
  any;
  
  setCurrentdate() {
    this.current_date = this.datepipe.transform(new Date(), 'dd/MM/yyyy');
    this.current_time = this.datepipe.transform(new Date(), 'HH:mm');
    this.createmeetingform.get('activity_date').setValue(this.current_date);
    this.createmeetingform.get('activity_time').setValue(this.current_time);
  }
  public showSpinner(): void {
    this.spinnerService.show();
  }

  getdata() {
    this.customers = [];
    for (const prop in this.ApiService.tabledatameeting) {
      this.customers.push(this.ApiService.tabledatameeting[prop]);
    }
    this.customers.pop();

    //this.ApiService.viewtableOB();
  }
  onInputNumber(event: any): void {
    const input = event.target.value;
    // Replace non-numeric characters with an empty string
    event.target.value = input.replace(/[^0-9]/g, '');
  }
  
  validateDOB(control: AbstractControl): { [key: string]: any } | null {
    const dobPattern = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/\d{4}$/;

    if (!control.value) {
      return null; // Return null if no value is entered
    }

    // Calculate age based on the entered date of birth
    const dob = new Date(control.value);
    const today = new Date();
    let age = today.getFullYear() - dob.getFullYear();

    // Adjust age if birthday hasn't occurred yet this year
    if (
      today.getMonth() < dob.getMonth() ||
      (today.getMonth() === dob.getMonth() && today.getDate() < dob.getDate())
    ) {
      age--;
    }

    // Check if the age is less than 15
    if (age < 15) {
      return { invalidAge: true }; // Return an error object if age is less than 15
    }

    return null; // Return null if age is valid
  }

  selectFiles(event: any) {
    if (event.target.files[0].size < 60000) {
      const formData: FormData = new FormData();
      formData.append('file', event.target.files[0]);
      this.ApiService.uploadActivityFile(formData).subscribe((da: any) => {
        this.uploadFiles = da;
      });
    } else {
      Swal.fire({
        position: "top-end",
        icon: "error",
        title: "The size should be less than 60kb",
        showConfirmButton: false,
        timer: 1500
      });
      $('#file').val('');
      
      // Mark the 'image' form control as invalid
      this.createmeetingform.get('image')?.setErrors({ 'imageSizeExceeded': true });
    }
  }
  
  
  imageSizeValidator(maxSize: number): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      if (control.value && control.value.size) {
        const fileSize = control.value.size; // Get the size of the file
        if (fileSize > maxSize) {
          return { 'imageSizeExceeded': true }; // Return an error if the size exceeds the limit
        }
      }
      return null; // Return null if the size is within the limit
    };
  }
  passwordMatchValidator(control: AbstractControl): ValidationErrors | null {
    const password = control.get('password');
    const confirm_password = control.get('confirm_password');

    if (password && confirm_password && password.value !== confirm_password.value) {
      return { 'passwordMismatch': true }; // Return error if passwords don't match
    }

    return null; // Return null if passwords match or any control is missing
  }

  handleBlurChange() {
    const password = this.createmeetingform.get('password').value;
    const confirm_password = this.createmeetingform.get('confirm_password').value;
    
    if (password !== confirm_password) {
      this.password_wrong = true;
    } else {
      this.password_wrong = false;
    }
  }

  test_ph = 'false';
  getphone(c) {
    if (this.createmeetingform.get('number').status == 'VALID') {
      this.ApiService.mentor_ph_check(c).subscribe((data) => {
        if(data == false) {
         
            this.test_ph = 'true';
        
          } else {
            this.test_ph = 'false';
          }
        
      });
    }
  }
  test_email = 'false';

  getemail(a) {
    if (this.createmeetingform.get('email').status == 'VALID') {
      console.log(a);
      this.ApiService.email_check_student(a).subscribe((data) => {
        if(data== false) {
         
            this.test_email = 'true';

            
          } else {
            this.test_email = 'false';
          }
        
      });
    }
  }

  postdata(
    angForm1: any //angForm1
  ) {
    let values = angForm1.value;
    values['image'] = this.uploadFiles;
    values['captcha']= this.recaptchaToken;
    this.spinner = true;

    this.ApiService.createStudentRegister(values).subscribe(
      (d: any) => {
        this.spinnerService.hide();

        setTimeout(function () {
          Swal.fire({
            icon: 'success',
            iconColor: '#015792',
            title: 'Your Registration is Successful..!',
            html: `
              <p>Login with your credentials(Refer: WhatsApp/Email)</p>
              <div style="display: flex; justify-content:center; margin-left:10px">
                <div style="margin-top: 15px;padding-left: 25px;margin-right: 7px;color: #015792;">Press</div>
                <button class="swal2-confirm swal2-styled" id="custom-ok-button" type="button" style="background-color: #015792;">Ok</button>
    
                <div style="margin-top: 15px; margin-left: 7px;color: #015792;">To Continue</div>`,
                showConfirmButton:false,
            focusConfirm: false,
            preConfirm: () => {
              // Redirect to the login page
              window.location.href = 'login';
            }
          });
        
          // Add click event listener to the custom Ok button
          document.getElementById('custom-ok-button').addEventListener('click', function() {
            // Trigger the preConfirm function to redirect to the login page
            Swal.clickConfirm();
          });
        }, 1000);
        
    });
  }
  delete_CM(id: any) {
    if (confirm('Are you sure want to cancel this Student Details ?')) {
      this.ApiService.deleteStudentRegister(id)
        .pipe()
        .subscribe(
          (data) => {
            window.location.reload();
            alert('Student Details has been Deleted!');
          },

          (error) => {
            console.log(error);
          }
        );
    }
  }

  radiobutton(option: any) {
    this.MeetingOptions = option;
  }
  Participants(a: any) {
    this.participantsptions = a;
    //dropdown overlay reduced for mobileview
    const popupelement =
      this.elementRef.nativeElement.querySelector('.modal-content');
    if (popupelement) {
      const targetElement = popupelement.querySelector('.dropdown-list');
      if (targetElement) {
        this.renderer.setStyle(targetElement, 'overflow-y', 'hidden');
      }
    }
  }
  CM_name: any;
  CM_meeting_location: any;
  CM_date: any;
  CM_time: any;
  CM_description: any;
  CM_activity_type: any;
  CM_comments: any;
  CM_participants: any;
  CM_constituency: any;
  CM_assigned_to: any;
  CM_status: any;
  CM_activity: any;
  CM_others: any;
  CM_district: any;
  CM_father_name: any;
  CM_DOB: any;
  CM_email: any;
  CM_number: any;
  CM_parent_number: any;
  CM_grade: any;
  CM_college_name: any;
  CM_subject: any;
  CM_image: any;

  editfield: boolean = false;
  buttonviewmeeting(a: any, editbutton: any) {
    if (editbutton == 'edit') {
      $('#card_title').html('STUDENT DETAILS EDIT');
      this.editfield = true;
    } else {
      $('#card_title').html('Student’s Details');
      this.editfield = false;
    }
    this.CM_name = a.name;
    this.CM_father_name = a.father_name;
    this.CM_DOB = a.DOB;
    this.CM_email = a.email;
    this.CM_number = a.number;
    this.CM_parent_number = a.parent_number;
    this.CM_grade = a.grade;
    this.CM_college_name = a.college_name;
    this.CM_district = a.district;
    this.CM_subject = a.subject;
    this.CM_image = a.image;
    this.uploadFiles = a.image;
    this.CM_id = a.id;

    this.editformInitialize(false);

    this.editmeetingform.get('name').setValue(a.name);
    this.editmeetingform.get('father_name').setValue(a.father_name);
    this.editmeetingform.get('DOB').setValue(a.DOB);
    this.editmeetingform.get('email').setValue(a.email);
    this.editmeetingform.get('number').setValue(a.number);
    this.editmeetingform.get('parent_number').setValue(a.parent_number);
    this.editmeetingform.get('grade').setValue(a.grade);
    this.editmeetingform.get('college_name').setValue(a.college_name);
    this.editmeetingform.get('district').setValue(a.district);
    this.editmeetingform.get('subject').setValue(a.subject);
  }

  editformInitialize(a) {
    this.editmeetingform = this.fb.group({
      name: ['', [Validators.required, Validators.pattern('[A-Za-z ]{1,32}')]],
      father_name: ['', Validators.required],
      DOB: [this.current_date, Validators.required],
      email: ['', Validators.required],
      number: ['', Validators.required],
      parent_number: ['', Validators.required],
      grade: ['', Validators.required],
      college_name: ['', Validators.required],
      district: ['', Validators.required],
      subject: ['', Validators.required],
      image: ['', Validators.required],
    });
  }

  updatedata(updateform, id) {
    let values = updateform.value;
    values['image'] = this.uploadFiles;
    // this.spinner = true;
    this.ApiService.updateStudentRegister(this.CM_id, values)
      .pipe()
      .subscribe(
        (data) => {
          this.spinnerService.hide();

          setTimeout(function () {
            Swal.fire({
                title: 'Student Registration has been updated!',
                icon: 'success',
                confirmButtonText: 'Okay',
                confirmButtonColor: '#015792', 
                iconColor: '#015792',
            }).then((result) => {
                if (result.isConfirmed) {
                    window.location.href = 'login';
                }
            });
        }, 100);  
        
        },

        (error) => {
          console.log(error);
        }
      );
  }
  //reset form values in createform
  Formreset() {
    this.createmeetingform.reset();
    this.hidden = true;
    this.MeetingOptions = '';
    this.participantsptions = '';
  }
  footerdate=new Date().getFullYear();
  hidePassword = true;
  togglePasswordVisibility(): void {
    this.hidePassword = !this.hidePassword;
  }
  hidepassword1= true;
  togglePassword():void{
    this.hidepassword1 = !this.hidepassword1;

  }

  close() {
    this.createmeetingform.reset(); // Resets the form (if applicable)
    // Optionally, navigate back or close the modal
    this.router.navigate(['']); // Adjust the route as needed
    // window.location.reload();
}
isFormDisabled(): boolean {
   
  return !this.createmeetingform.valid || (this.test_email ==='true') || (this.test_ph ==='true') ||  !this.captchaResolved;

}
passwordValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const password = control.value;
    
    if (!password) {
      return null; // Return null if there's no input yet
    }

    const hasUpperCase = /[A-Z]/.test(password);
    const hasLowerCase = /[a-z]/.test(password);
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);
    const hasMinLength = password.length >= 8;

    const passwordValid = hasUpperCase && hasLowerCase && hasSpecialChar && hasMinLength;

    return !passwordValid ? { passwordStrength: true } : null;
  };
}
// onKeyPressName(event: KeyboardEvent): void {
//   const key = event.key;
//   const allowedCharacters = /^[A-Za-z ]$/;
  
//   if (!allowedCharacters.test(key)) {
//     event.preventDefault(); // Prevents the character from being typed
//   }
// }
onInputName(event: Event): void {
  const inputElement = event.target as HTMLInputElement;
  const value = inputElement.value;
  const allowedCharacters = /^[A-Za-z ]*$/;

  // Remove any disallowed characters
  if (!allowedCharacters.test(value)) {
    inputElement.value = value.replace(/[^A-Za-z ]/g, '');
  }
}

// Method to validate and format input for Course/Grade
onInputCourse(event: Event): void {
  const inputElement = event.target as HTMLInputElement;
  let value = inputElement.value;

  // Replace any disallowed characters and multiple spaces with a single space
  value = value.replace(/[^0-9A-Za-z ,.'-]/g, '').replace(/\s{2,}/g, ' ');

  // Update the input element's value
  inputElement.value = value;
}

// Method to validate and format input for Institution Name
onInputInstitution(event: Event): void {
  const inputElement = event.target as HTMLInputElement;
  let value = inputElement.value;

  // Replace any disallowed characters and multiple spaces with a single space
  value = value.replace(/[^A-Za-z ,.'-]/g, '').replace(/\s{2,}/g, ' ');

  // Update the input element's value
  inputElement.value = value;
}

onKeyPressNumber(event: KeyboardEvent): void {
  const key = event.key;
  const allowedCharacters = /^[0-9]$/;

 // Get the current value and check the length
 const input = (event.target as HTMLInputElement).value;

 // Allow only numbers and limit to 10 characters
 if (!allowedCharacters.test(key) || input.length >= 10) {
   event.preventDefault(); // Prevents the character from being typed
 }
}
}
